export default "__VITE_ASSET__91418870__"